/**
 * Labstep
 *
 * @module components/FilterPost/Report/Entity/Form
 * @desc Filter Entity form
 */

import { FormReusableGroup } from 'labstep-web/core/Form/Reusable/Group';
import { PostFilter } from 'labstep-web/services/postFilter';
import type { PostFilterComparisonType } from 'labstep-web/services/postFilter/constants';
import {
  PostFilterComparison,
  PostFilterOperator,
} from 'labstep-web/services/postFilter/constants';
import type React from 'react';
import { useCallback } from 'react';
import { getFieldSearchSelectEntity } from './fields';
import type { FilterPostReportEntityFormProps } from './types';

export const getPostFilterEntity = (
  field: string,
  comparison: PostFilterComparisonType,
  path?: string,
) => {
  return new PostFilter([[field, comparison]], path);
};

export const getPostFilterEntityWithName = (
  field: string,
  comparison: PostFilterComparisonType,
  path?: string,
) => {
  return new PostFilter(
    [
      ['name', PostFilterComparison.eq],
      new PostFilter([[field, comparison]], path),
    ],
    'protocolValues',
  );
};

export const FilterPostReportEntityForm: React.FC<
  FilterPostReportEntityFormProps
> = ({
  addPostFilter,
  onDone,
  path,
  field,
  defaultValues,
  entityName,
  protocolValueName,
}) => {
  const onSubmit = useCallback(
    (values): void => {
      const { entity_id } = values;
      if (protocolValueName) {
        const complexFilterNode = {
          type: PostFilterOperator.and,
          path: 'protocolValues',
          predicates: [
            {
              attribute: 'name',
              comparison: PostFilterComparison.eq,
              value: protocolValueName,
            },
            getPostFilterEntity(
              field,
              PostFilterComparison.eq,
              path,
            ).getNode([entity_id]),
          ],
        };

        addPostFilter(complexFilterNode as any);
      } else {
        addPostFilter(
          getPostFilterEntity(
            field,
            PostFilterComparison.eq,
            path,
          ).getNode([entity_id]),
          true,
        );
      }
      onDone();
    },
    [path, addPostFilter],
  );

  return (
    <FormReusableGroup
      fields={[getFieldSearchSelectEntity(entityName)]}
      onSubmit={onSubmit}
      onDone={onDone}
      defaultValues={defaultValues}
      addAnother={false}
    />
  );
};
